import { useState } from "react";

import { FIRST_PAGE } from "./TaxInvoices.consts";

/** Tracks the current page and the slice of records it covers. */
const usePagination = (total = 0, countPerPage = 1) => {
  const [page, setPage] = useState(FIRST_PAGE);

  const skip = (page - FIRST_PAGE) * countPerPage;
  const pageCount = Math.ceil(total / countPerPage || 1);
  const totalCount = total || 1;
  const limit = countPerPage;

  return { limit, page, pageCount, setPage, skip, totalCount };
};

export { usePagination };
